class LocalStorageManager {
  prefix = 'anna_';

  getItem(key, withExpiresDate) {
    try {
      const fullKey = `${this.prefix}${key}`;
      const item = localStorage.getItem(fullKey);
      if (!item) {
        return undefined;
      }

      const data = JSON.parse(item);
      const expires = data.expire || data.expires;
      if (expires) {
        const expireDate = new Date(expires);
        if (expireDate < new Date()) {
          return undefined;
        }
      }

      // Unused cause backend response with wrong value (120 minutes is fake, 24 hours is real)
      if (withExpiresDate) {
        return {
          data: data.data,
          expires: expires ? new Date(expires) : undefined,
        };
      }

      return { access_token: data.data };
    } catch (err) {
      return undefined;
    }
  }

  setItem = (key, data, expires) => {
    try {
      const fullKey = `${this.prefix}${key}`;
      const isDate = expires instanceof Date;
      let expireDate = expires;
      if (!isDate) {
        expireDate = new Date();
        expireDate.setMinutes(expireDate.getMinutes() + expires);
      }

      const item = {
        expires: expires ? expireDate : undefined,
        data,
      };

      localStorage.setItem(fullKey, JSON.stringify(item));
    } catch (err) {
      console.error(err);
    }
  }

  removeItem = (key) => {
    try {
      const fullKey = `${this.prefix}${key}`;
      localStorage.removeItem(fullKey);
    } catch (err) {
      console.error(err);
    }
  }
}

const defaultManager = new LocalStorageManager();

export default defaultManager;
